export enum ChatAttachmentType {
  PPT = 'cng-ico_doc_ppt',
  PPTX = 'cng-ico_doc_ppt',
  DOC = 'cng-ico_doc_word',
  DOCX = 'cng-ico_doc_word',
  XLS = 'cng-ico_doc_excel',
  XLSX = 'cng-ico_doc_excel',
  PDF = 'cng-ico_doc_pdf',
}
